import { useContext } from 'react';
import { FormContext } from '../shared';
export var useForm = function () {
    return useContext(FormContext);
};
//# sourceMappingURL=useForm.js.map